var _rect, _path, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIssuedTariffs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_277_1336)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 46C45 50.4183 39.1797 49 32 49C24.8203 49 19 50.4183 19 46C19 41.5817 24.8203 36 32 36C39.1797 36 45 41.5817 45 46Z",
    fill: "#404040"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 27,
    rx: 7,
    ry: 8,
    fill: "#404040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_277_1336",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_277_1336",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_277_1336",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADeUlEQVR4nO3dvWsUQRgG8Bk/OwsVBSt7UcFge88zm+Q4bPVsFbTxf1AM+C/oFRNsLUwjgjai2AqCELFRFO2Mgl3wIyYjCyucR7J3J8nuOzPvA287zM6Pd+b22L0zRqPRaDQajUaj0Wg0Go1mR1MUxSkAdwF8IvmLZNjOArBCcpnkEoDLAA63fc1SY0neBLC+3Qhjao3k4tzc3LG2F0AaxqBhiNHOWQVwre2FkBDbNsZIDQDsMZnGArgtAGG0W+6YDGOFdcYoSlbbl20YYw3ACwAPADwn+W0CkNVcDnrbFEZ1UN/odrsHhydQnhEkz5N8O2YMbxKPbbAzvhRFcaZuMr1e7wDJJ3WdNTs7e8gkGttgZ6w75zqTTKpCeVcz3iWTYGzDZ8a9aSYH4ELNWEsmsdimP9o657rTTHBmZmZvzUH/yiQU28Z9xv/s+9Wnr822vxWTSGxb9xm9Xm//tJMl+XCL8TZMArFt3vQBOD7thAG83Go8E3msgDvwK9NMuPwKHsDvFEGskO+mlvv9/u5JJ03yVt14JtJYAZ0xvG0tTDLpTqdzluT31ECsJIyqNkqUuk5xzhUkv44by0QWiRhhqF4DuFoe9P1+f19RFEedc+dI3i/RJhnDRBQpZ0bYyTKRJAsMRgKSDQYjAMkKg8JBssOgYJAsMSgUJFsMCgTJGoPCQLLHoCAQxaAcEMWgHBDFoBwQxaAcEOnf2oY2CsBPxaCo+qAYFFWLjWLomcFxj6SeVgzKKADXG8PQbYrjalCuUyMY2hkME7wXsksxmBmGblMUs02Vj0suCLjgILga64zy6byTLfxCQoiomsMoU/52iICLDsx9mxoC+SjgwoPAah6jAvkh4OKDsGoHo8wkDxRnVoPWMCqQxwIWIWR5gG8W59xFAQsRmHtnDGUXyWcCFiQoxr/v0b0RsDAhe4y/mZ+fP1K+wCJggUJWZ0ZdMkPxojEyQ/FRYGSC4qPCSBzFR4mRKIqPGiMxFJ8ERiIoPimMyFF8khiRovikMSJD8VlgRILis8IQjuKzxBCK4rPGEIbiFUMOilcMOSheMeSgeMWQg+IVQw6KVww5KF4x5KB4xZCD4hVDDopXDDkoXjHkoHjFaO6x1adbQZR/DVG9lC/v8c6EYwH0ATwC8Ll8aQjA+7IrnHMn2p6cRqPRaDQajUaj0Wg0GpN4/gB0TmP1aNUK9gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuedTariffs);
export default __webpack_public_path__ + "static/media/issued-tariffs.683a76c66c3029a48b33b8f6b2fb0b2f.svg";
export { ForwardRef as ReactComponent };